import { render } from "./Language.vue?vue&type=template&id=b4082518&scoped=true"
import script from "./Language.vue?vue&type=script&lang=ts"
export * from "./Language.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-b4082518"

export default script